import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  findMyTeam: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          findMyTeam {
            number
            firstName {
              current
            }
            lastName {
              current
            }
            patronymic {
              current
            }
            phone
            telegramChat
            telegramUsername
          }
        }
      `,
    }),
  ),
})
